<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    max-width="600"
  >
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="primary" dark>他/她配置</v-toolbar>
        <v-card-text>
          <div class="pa-12">
            <v-col sm="6">
              <v-form ref="form" @submit.prevent="submitForm">
                <v-text-field
                  placeholder="想好了输入哈"
                  label="姓名 | 外号"
                  v-model="form.name"
                  :rules="rules"
                  counter="10"
                  outlined
                  append-outer-icon="mdi-check"
                  @click:append-outer="submitForm"
                ></v-text-field>
              </v-form>
            </v-col>
            <v-chip
              class="ma-2"
              color="indigo"
              close
              label
              outlined
              @click:close="closeName(item)"
              v-for="item in nameArr"
              :key="item.name"
            >
              <v-avatar left>
                <v-icon>mdi-account-circle</v-icon>
              </v-avatar>
              {{ item.name }}
            </v-chip>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog.value = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { nameAdd, nameList, nameDelete } from "@/api/node.js";
export default {
  name: "editName",
  data() {
    return {
      dialog: false,
      nameArr: [],
      form: {
        name: ""
      },
      rules: [v => !!v || "请输入内容", v => v.length <= 10 || "超过10个字符"]
    };
  },
  created() {
    this.nameList();
  },
  watch: {
    dialog: {
      handler(val) {
        if (!val) {
          this.$emit("updateList");
        }
      }
    }
  },
  methods: {
    closeName(item) {
      nameDelete({ name: item.name }).then(() => {
        this.$message.success("删除成功");
        this.nameList();
      });
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        nameAdd(this.form).then(() => {
          this.$message.success("添加成功");
          this.nameList();
          this.form.name = "";
          this.$refs.form.resetValidation();
        });
      }
    },
    nameList() {
      nameList().then(res => {
        this.nameArr = res.data;
      });
    }
  }
};
</script>

<style></style>
